import { APIService } from "services";


const designationlevelId = parseInt(localStorage.getItem("desig_level_id"));
const vibahgId = localStorage.getItem("vibhag_id");
const zillId = localStorage.getItem("zill_id");
const nagarkhandId = localStorage.getItem("nagar_khanda_id");
const upamandabastiId = localStorage.getItem("upamandal_basti_id");



// console.log("designationlevelId", designationlevelId);
export const getVw_Members = async (pageNo, pageSize, search) => {
    let res;
    if (search.length === 0) {
        res = await getAllVw_Members(search, pageNo, pageSize);
    }
    else {
        try {
            res = await searchVw_Members(search, pageNo, pageSize);
        } catch (err) {
            return { records: [], totalCount: 0 }
        }
    }
    if (res && res.data) {
        return res.data;
    } else {
        return { records: [], totalCount: 0 }
    }

}


export const getAllVw_Members = (search, pageNo, pageSize) => {
    if (designationlevelId == 1) {
        console.log("0")
        return APIService.api().post(`/vw_members/searchWithFields`, { "stayi": "1" })
    } else if (designationlevelId == 2) {
        console.log("1");
        return APIService.api().post(`/vw_members/searchWithFields`, { "stayi": "2" })
    } else if (designationlevelId == 3) {
        console.log("2");
        return APIService.api().post(`/vw_members/searchWithFields`, { "stayi": "3", vibhag: vibahgId })
    } else if (designationlevelId == 4) {
        return APIService.api().post(`/vw_members/searchWithFields`, { "stayi": "4", zilla: zillId })
    } else if (designationlevelId == 5) {
        return APIService.api().post(`/vw_members/searchWithFields`, { "stayi": "5", nagar_khanda: nagarkhandId })
    } else if (designationlevelId == 6) {
        return APIService.api().post(`/vw_members/searchWithFields`, { "stayi": "6", upamandal_basti: upamandabastiId })
    }
}
export const getOneVw_Members = (member_id) => {
    return APIService.api().get(`/vw_members/${member_id}`)
}

export const searchVw_Members = (searchKey, pageNo, pageSize) => {
    console.log("3")
    return APIService.api().post(`/vw_members/searchWithFields`, searchKey)

}

export const updateMembers = (member_id, data) => {
    return APIService.api().patch(`/members/${member_id}`, data)
}

export const deleteMembers = (member_id) => {
    return APIService.api().post(`/members/updateStatus`,member_id);
}
